import { NODE_CATEGORIES } from '../../../../../constants/workflow.constant';

export const getNodeFormIds = (node) => {
  const formConfig = node?.data?.formConfig || {};
  const formIds = formConfig.form_ids || [];
  const singleFormId = formConfig.form_id;

  if (formIds.length > 0) return formIds;
  if (singleFormId) return [singleFormId];
  return [];
};

export const findUpstreamNodeIds = (targetNodeId, currentEdges, newEdge) => {
  const allEdges = newEdge ? [...currentEdges, newEdge] : currentEdges;
  const upstreamIds = new Set();

  const traverse = (nodeId, visited = new Set()) => {
    if (visited.has(nodeId)) return;
    visited.add(nodeId);

    const incomingEdges = allEdges.filter((edge) => edge.target === nodeId);
    for (const edge of incomingEdges) {
      upstreamIds.add(edge.source);
      traverse(edge.source, visited);
    }
  };

  traverse(targetNodeId);
  return upstreamIds;
};

export const getAssessmentParentReviewId = (
  assessmentReviewNodeId,
  currentEdges,
  nodes
) => {
  const staEdge = currentEdges.find((e) => e.target === assessmentReviewNodeId);
  if (!staEdge) return null;

  const staNode = nodes.find(
    (n) => n.id === staEdge.source && n.category === NODE_CATEGORIES.CHILD_STA
  );
  if (!staNode) return null;

  const reviewEdge = currentEdges.find((e) => e.target === staNode.id);
  if (!reviewEdge) return null;

  const reviewNode = nodes.find(
    (n) => n.id === reviewEdge.source && n.category === NODE_CATEGORIES.REVIEW
  );
  return reviewNode?.id || null;
};

export const findDownstreamFormIds = (
  fromNodeId,
  toNodeId,
  nodes,
  currentEdges
) => {
  const formIds = new Set();
  const visited = new Set();

  const nodesReachableToTarget = new Set();
  const reverseTraverse = (nodeId, visitedReverse = new Set()) => {
    if (visitedReverse.has(nodeId)) return;
    visitedReverse.add(nodeId);
    nodesReachableToTarget.add(nodeId);
    const incomingEdges = currentEdges.filter((edge) => edge.target === nodeId);
    for (const edge of incomingEdges) {
      reverseTraverse(edge.source, visitedReverse);
    }
  };
  reverseTraverse(toNodeId);

  const traverse = (nodeId) => {
    if (visited.has(nodeId) || nodeId === toNodeId) return;
    visited.add(nodeId);

    const node = nodes.find((n) => n.id === nodeId);
    if (
      node?.category === NODE_CATEGORIES.SUBMISSION &&
      nodesReachableToTarget.has(nodeId)
    ) {
      const nodeFormIds = getNodeFormIds(node);
      nodeFormIds.forEach((id) => formIds.add(id));
    }

    if (nodesReachableToTarget.has(nodeId) || nodeId === fromNodeId) {
      const outgoingEdges = currentEdges.filter(
        (edge) => edge.source === nodeId
      );
      for (const edge of outgoingEdges) {
        traverse(edge.target);
      }
    }
  };

  traverse(fromNodeId);
  return formIds;
};
